import { NgModule } from '@angular/core';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { MaterialModule, UiModule, ZorroModule } from '@menatcode/purpletree';
import { RouterModule } from '@angular/router';
import { ApiCommands } from './api.commands';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalService } from './services/modal.service';
import { LoaderComponent } from './components/loader/loader.component';

import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import {HeaderComponent} from "./components/header/header.component";
import {SidebarComponent} from "./components/sidebar/sidebar.component";
@NgModule({
    declarations: [
        LoaderComponent,
        HeaderComponent,
        SidebarComponent
    ],
    imports: [
        AngularCommonModule,
        RouterModule,
        BreadcrumbModule,
        ZorroModule,
        UiModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        LottieModule.forRoot({ player: playerFactory })
    ],
    exports: [
        LoaderComponent,
        HeaderComponent,
        SidebarComponent
    ],
    providers: [
        ApiCommands,
        ModalService
    ]
})
export class CommonModule {
}

export function playerFactory() {
    return player;
}
